import axios from '@/axios'


const upgrade = {
  // 用户中心-账户升级-用户专业账户资料详情API(直客)
  async getAccountUpgrade(params) {
    return await axios.post('/uc/ucUpgrade/getAccountUpgrade', params, { des: '直客pc用户专业账户资料详情API', sTime: new Date().getTime() })
  },
  // 用户中心-账户升级-用户问卷分数添加API(直客)
  async addQuestionnaireScore(params) {
    return await axios.post('/uc/ucUpgrade/addQuestionnaireScore', params, { des: '直客pc用户问卷分数添加API', sTime: new Date().getTime() })
  },
  // 用户中心-账户升级-专业账户资料添加API(直客)
  async addAccountUpgrade(params) {
    return await axios.post('/uc/ucUpgrade/addAccountUpgrade', params, { des: '直客pc专业账户资料添加API', sTime: new Date().getTime() })
  },
  // 用户中心-账户升级-专业账户资料图片上传API(直客)
  async ucAccountUpgradeimg(params) {
    return await axios.post('/uc/ucUpgrade/ucAccountUpgradeimg', params, { des: '直客pc专业账户资料图片上传API', sTime: new Date().getTime() })
  },
  // 用户中心-账户升级-直客专属账户设置API(直客)
  async queryExclusiveAccountSetting(params) {
    return await axios.post('/uc/ucUpgrade/queryExclusiveAccountSetting', params, { des: '直客pc获取账户资料基本信息', sTime: new Date().getTime() })
  }
}

export default upgrade


// WEBPACK FOOTER //
// ./src/api/upgrade.js